export default [
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/3TVXtAsR1Inumwj472S9r4'
          },
          href: 'https://api.spotify.com/v1/artists/3TVXtAsR1Inumwj472S9r4',
          id: '3TVXtAsR1Inumwj472S9r4',
          name: 'Drake',
          type: 'artist',
          uri: 'spotify:artist:3TVXtAsR1Inumwj472S9r4'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/1ATL5GLyefJaxhQzSPVrLX'
      },
      href: 'https://api.spotify.com/v1/albums/1ATL5GLyefJaxhQzSPVrLX',
      id: '1ATL5GLyefJaxhQzSPVrLX',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/542d705154be4049fc927050d006987e63739bbd',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/239ec906572231368d8ebd72614094bd3bd10b33',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/f12257240bbec6ddfa780253ac939e646eba2a36',
          width: 64
        }
      ],
      name: 'Scorpion',
      type: 'album',
      uri: 'spotify:album:1ATL5GLyefJaxhQzSPVrLX'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/3TVXtAsR1Inumwj472S9r4'
        },
        href: 'https://api.spotify.com/v1/artists/3TVXtAsR1Inumwj472S9r4',
        id: '3TVXtAsR1Inumwj472S9r4',
        name: 'Drake',
        type: 'artist',
        uri: 'spotify:artist:3TVXtAsR1Inumwj472S9r4'
      }
    ],
    disc_number: 1,
    duration_ms: 214466,
    explicit: true,
    external_ids: {
      isrc: 'USCM51800121'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/3qN5qMTKyEEmiTZD38BNTT'
    },
    href: 'https://api.spotify.com/v1/tracks/3qN5qMTKyEEmiTZD38BNTT',
    id: '3qN5qMTKyEEmiTZD38BNTT',
    is_playable: true,
    name: "I'm Upset",
    popularity: 84,
    preview_url: null,
    track_number: 6,
    type: 'track',
    uri: 'spotify:track:3qN5qMTKyEEmiTZD38BNTT'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/2jku7tDXc6XoB6MO2hFuqg'
          },
          href: 'https://api.spotify.com/v1/artists/2jku7tDXc6XoB6MO2hFuqg',
          id: '2jku7tDXc6XoB6MO2hFuqg',
          name: 'Tory Lanez',
          type: 'artist',
          uri: 'spotify:artist:2jku7tDXc6XoB6MO2hFuqg'
        },
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/1pPmIToKXyGdsCF6LmqLmI'
          },
          href: 'https://api.spotify.com/v1/artists/1pPmIToKXyGdsCF6LmqLmI',
          id: '1pPmIToKXyGdsCF6LmqLmI',
          name: 'Rich The Kid',
          type: 'artist',
          uri: 'spotify:artist:1pPmIToKXyGdsCF6LmqLmI'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/1aUmziQmPRCuIEOa6noB16'
      },
      href: 'https://api.spotify.com/v1/albums/1aUmziQmPRCuIEOa6noB16',
      id: '1aUmziQmPRCuIEOa6noB16',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/87fd017e2c1620dd0a02a859692bc49498c845e5',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/569fe5acea6caf7f8ed645ced7f16777cf874400',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/5a5e21f038f0d0d373df33a50de224a5ea462ccc',
          width: 64
        }
      ],
      name: 'TAlk tO Me (with Rich The Kid)',
      type: 'album',
      uri: 'spotify:album:1aUmziQmPRCuIEOa6noB16'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/2jku7tDXc6XoB6MO2hFuqg'
        },
        href: 'https://api.spotify.com/v1/artists/2jku7tDXc6XoB6MO2hFuqg',
        id: '2jku7tDXc6XoB6MO2hFuqg',
        name: 'Tory Lanez',
        type: 'artist',
        uri: 'spotify:artist:2jku7tDXc6XoB6MO2hFuqg'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/1pPmIToKXyGdsCF6LmqLmI'
        },
        href: 'https://api.spotify.com/v1/artists/1pPmIToKXyGdsCF6LmqLmI',
        id: '1pPmIToKXyGdsCF6LmqLmI',
        name: 'Rich The Kid',
        type: 'artist',
        uri: 'spotify:artist:1pPmIToKXyGdsCF6LmqLmI'
      }
    ],
    disc_number: 1,
    duration_ms: 184489,
    explicit: true,
    external_ids: {
      isrc: 'USUM71808046'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/49NhxprbG9oTtMunQCSXxA'
    },
    href: 'https://api.spotify.com/v1/tracks/49NhxprbG9oTtMunQCSXxA',
    id: '49NhxprbG9oTtMunQCSXxA',
    is_playable: true,
    name: 'TAlk tO Me (with Rich The Kid)',
    popularity: 79,
    preview_url: null,
    track_number: 1,
    type: 'track',
    uri: 'spotify:track:49NhxprbG9oTtMunQCSXxA'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/699OTQXzgjhIYAHMy9RyPD'
          },
          href: 'https://api.spotify.com/v1/artists/699OTQXzgjhIYAHMy9RyPD',
          id: '699OTQXzgjhIYAHMy9RyPD',
          name: 'Playboi Carti',
          type: 'artist',
          uri: 'spotify:artist:699OTQXzgjhIYAHMy9RyPD'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/7dAm8ShwJLFm9SaJ6Yc58O'
      },
      href: 'https://api.spotify.com/v1/albums/7dAm8ShwJLFm9SaJ6Yc58O',
      id: '7dAm8ShwJLFm9SaJ6Yc58O',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/03d4fc7b3df5aa9dded70438699f250e4301bf62',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/eb7fa6afda95fadfb67a90c036b555f6049998b2',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/0fe792690a47877c04119d29ac69060c0be6b234',
          width: 64
        }
      ],
      name: 'Die Lit',
      type: 'album',
      uri: 'spotify:album:7dAm8ShwJLFm9SaJ6Yc58O'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/699OTQXzgjhIYAHMy9RyPD'
        },
        href: 'https://api.spotify.com/v1/artists/699OTQXzgjhIYAHMy9RyPD',
        id: '699OTQXzgjhIYAHMy9RyPD',
        name: 'Playboi Carti',
        type: 'artist',
        uri: 'spotify:artist:699OTQXzgjhIYAHMy9RyPD'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/4O15NlyKLIASxsJ0PrXPfz'
        },
        href: 'https://api.spotify.com/v1/artists/4O15NlyKLIASxsJ0PrXPfz',
        id: '4O15NlyKLIASxsJ0PrXPfz',
        name: 'Lil Uzi Vert',
        type: 'artist',
        uri: 'spotify:artist:4O15NlyKLIASxsJ0PrXPfz'
      }
    ],
    disc_number: 1,
    duration_ms: 153800,
    explicit: true,
    external_ids: {
      isrc: 'USUM71804149'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/2BJSMvOGABRxokHKB0OI8i'
    },
    href: 'https://api.spotify.com/v1/tracks/2BJSMvOGABRxokHKB0OI8i',
    id: '2BJSMvOGABRxokHKB0OI8i',
    is_playable: true,
    name: 'Shoota (feat. Lil Uzi Vert)',
    popularity: 81,
    preview_url: null,
    track_number: 6,
    type: 'track',
    uri: 'spotify:track:2BJSMvOGABRxokHKB0OI8i'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/0Y5tJX1MQlPlqiwlOH1tJY'
          },
          href: 'https://api.spotify.com/v1/artists/0Y5tJX1MQlPlqiwlOH1tJY',
          id: '0Y5tJX1MQlPlqiwlOH1tJY',
          name: 'Travis Scott',
          type: 'artist',
          uri: 'spotify:artist:0Y5tJX1MQlPlqiwlOH1tJY'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/41GuZcammIkupMPKH2OJ6I'
      },
      href: 'https://api.spotify.com/v1/albums/41GuZcammIkupMPKH2OJ6I',
      id: '41GuZcammIkupMPKH2OJ6I',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/cdca7dc20c778ada42fb18506ea1f26857f01d17',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/1ab97df000596d224199bbf7492e2bb5d09ea297',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/092f661e5290a05410f1696e608cb140461b7ebf',
          width: 64
        }
      ],
      name: 'ASTROWORLD',
      type: 'album',
      uri: 'spotify:album:41GuZcammIkupMPKH2OJ6I'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/0Y5tJX1MQlPlqiwlOH1tJY'
        },
        href: 'https://api.spotify.com/v1/artists/0Y5tJX1MQlPlqiwlOH1tJY',
        id: '0Y5tJX1MQlPlqiwlOH1tJY',
        name: 'Travis Scott',
        type: 'artist',
        uri: 'spotify:artist:0Y5tJX1MQlPlqiwlOH1tJY'
      }
    ],
    disc_number: 1,
    duration_ms: 217828,
    explicit: true,
    external_ids: {
      isrc: 'USSM11806671'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/58TaFP5j5i9swOf584yon2'
    },
    href: 'https://api.spotify.com/v1/tracks/58TaFP5j5i9swOf584yon2',
    id: '58TaFP5j5i9swOf584yon2',
    is_playable: true,
    name: 'HOUSTONFORNICATION',
    popularity: 82,
    preview_url:
      'https://p.scdn.co/mp3-preview/c5d1f6daa24a7b0dd7e9c4adcdee9108e4545e21?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 16,
    type: 'track',
    uri: 'spotify:track:58TaFP5j5i9swOf584yon2'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/6oMuImdp5ZcFhWP0ESe6mG'
          },
          href: 'https://api.spotify.com/v1/artists/6oMuImdp5ZcFhWP0ESe6mG',
          id: '6oMuImdp5ZcFhWP0ESe6mG',
          name: 'Migos',
          type: 'artist',
          uri: 'spotify:artist:6oMuImdp5ZcFhWP0ESe6mG'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/7fd7SEK25VS3gJAUgSwL6y'
      },
      href: 'https://api.spotify.com/v1/albums/7fd7SEK25VS3gJAUgSwL6y',
      id: '7fd7SEK25VS3gJAUgSwL6y',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/79ef8fb6e772a47e3e045a747376dca7b900583e',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/dfc7c4f6f238bdd64f37c707e82a9b91cf3a0910',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/201f4f292e8b418759f811bed70b69855ac69960',
          width: 64
        }
      ],
      name: 'Culture II',
      type: 'album',
      uri: 'spotify:album:7fd7SEK25VS3gJAUgSwL6y'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/6oMuImdp5ZcFhWP0ESe6mG'
        },
        href: 'https://api.spotify.com/v1/artists/6oMuImdp5ZcFhWP0ESe6mG',
        id: '6oMuImdp5ZcFhWP0ESe6mG',
        name: 'Migos',
        type: 'artist',
        uri: 'spotify:artist:6oMuImdp5ZcFhWP0ESe6mG'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/0hCNtLu0JehylgoiP8L4Gh'
        },
        href: 'https://api.spotify.com/v1/artists/0hCNtLu0JehylgoiP8L4Gh',
        id: '0hCNtLu0JehylgoiP8L4Gh',
        name: 'Nicki Minaj',
        type: 'artist',
        uri: 'spotify:artist:0hCNtLu0JehylgoiP8L4Gh'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/4kYSro6naA4h99UJvo89HB'
        },
        href: 'https://api.spotify.com/v1/artists/4kYSro6naA4h99UJvo89HB',
        id: '4kYSro6naA4h99UJvo89HB',
        name: 'Cardi B',
        type: 'artist',
        uri: 'spotify:artist:4kYSro6naA4h99UJvo89HB'
      }
    ],
    disc_number: 1,
    duration_ms: 303076,
    explicit: true,
    external_ids: {
      isrc: 'USUM71712002'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/4wFjTWCunQFKtukqrNijEt'
    },
    href: 'https://api.spotify.com/v1/tracks/4wFjTWCunQFKtukqrNijEt',
    id: '4wFjTWCunQFKtukqrNijEt',
    is_playable: true,
    name: 'MotorSport',
    popularity: 81,
    preview_url: null,
    track_number: 17,
    type: 'track',
    uri: 'spotify:track:4wFjTWCunQFKtukqrNijEt'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/7bXgB6jMjp9ATFy66eO08Z'
          },
          href: 'https://api.spotify.com/v1/artists/7bXgB6jMjp9ATFy66eO08Z',
          id: '7bXgB6jMjp9ATFy66eO08Z',
          name: 'Chris Brown',
          type: 'artist',
          uri: 'spotify:artist:7bXgB6jMjp9ATFy66eO08Z'
        },
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/5LHRHt1k9lMyONurDHEdrp'
          },
          href: 'https://api.spotify.com/v1/artists/5LHRHt1k9lMyONurDHEdrp',
          id: '5LHRHt1k9lMyONurDHEdrp',
          name: 'Tyga',
          type: 'artist',
          uri: 'spotify:artist:5LHRHt1k9lMyONurDHEdrp'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/4neocSMt40stXKK2B8Sy2G'
      },
      href: 'https://api.spotify.com/v1/albums/4neocSMt40stXKK2B8Sy2G',
      id: '4neocSMt40stXKK2B8Sy2G',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/b9c66e564827b896ae108fc5c6229ef6c48c59e6',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/8360cc5edb8b8de8ac5f3c711dd6fa822b1e4ec5',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/6bf6a2bd5c44f728f0ebf7124be92a8c5944ab7b',
          width: 64
        }
      ],
      name: 'Fan of A Fan The Album (Deluxe Version)',
      type: 'album',
      uri: 'spotify:album:4neocSMt40stXKK2B8Sy2G'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/7bXgB6jMjp9ATFy66eO08Z'
        },
        href: 'https://api.spotify.com/v1/artists/7bXgB6jMjp9ATFy66eO08Z',
        id: '7bXgB6jMjp9ATFy66eO08Z',
        name: 'Chris Brown',
        type: 'artist',
        uri: 'spotify:artist:7bXgB6jMjp9ATFy66eO08Z'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/5LHRHt1k9lMyONurDHEdrp'
        },
        href: 'https://api.spotify.com/v1/artists/5LHRHt1k9lMyONurDHEdrp',
        id: '5LHRHt1k9lMyONurDHEdrp',
        name: 'Tyga',
        type: 'artist',
        uri: 'spotify:artist:5LHRHt1k9lMyONurDHEdrp'
      }
    ],
    disc_number: 1,
    duration_ms: 225226,
    explicit: true,
    external_ids: {
      isrc: 'USRC11403042'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/0k6DnZMLoEUH8NGD5zh2SE'
    },
    href: 'https://api.spotify.com/v1/tracks/0k6DnZMLoEUH8NGD5zh2SE',
    id: '0k6DnZMLoEUH8NGD5zh2SE',
    is_playable: true,
    name: 'Ayo',
    popularity: 74,
    preview_url:
      'https://p.scdn.co/mp3-preview/cf4f1af69fe88c57d54e2d9a6f2ef74ea05d731b?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 3,
    type: 'track',
    uri: 'spotify:track:0k6DnZMLoEUH8NGD5zh2SE'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/3TVXtAsR1Inumwj472S9r4'
          },
          href: 'https://api.spotify.com/v1/artists/3TVXtAsR1Inumwj472S9r4',
          id: '3TVXtAsR1Inumwj472S9r4',
          name: 'Drake',
          type: 'artist',
          uri: 'spotify:artist:3TVXtAsR1Inumwj472S9r4'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/1ATL5GLyefJaxhQzSPVrLX'
      },
      href: 'https://api.spotify.com/v1/albums/1ATL5GLyefJaxhQzSPVrLX',
      id: '1ATL5GLyefJaxhQzSPVrLX',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/542d705154be4049fc927050d006987e63739bbd',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/239ec906572231368d8ebd72614094bd3bd10b33',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/f12257240bbec6ddfa780253ac939e646eba2a36',
          width: 64
        }
      ],
      name: 'Scorpion',
      type: 'album',
      uri: 'spotify:album:1ATL5GLyefJaxhQzSPVrLX'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/3TVXtAsR1Inumwj472S9r4'
        },
        href: 'https://api.spotify.com/v1/artists/3TVXtAsR1Inumwj472S9r4',
        id: '3TVXtAsR1Inumwj472S9r4',
        name: 'Drake',
        type: 'artist',
        uri: 'spotify:artist:3TVXtAsR1Inumwj472S9r4'
      }
    ],
    disc_number: 1,
    duration_ms: 163974,
    explicit: true,
    external_ids: {
      isrc: 'USCM51800215'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/1dUHF4RyMmMTveJ0Rby6Xm'
    },
    href: 'https://api.spotify.com/v1/tracks/1dUHF4RyMmMTveJ0Rby6Xm',
    id: '1dUHF4RyMmMTveJ0Rby6Xm',
    is_playable: true,
    name: 'Can’t Take A Joke',
    popularity: 80,
    preview_url: null,
    track_number: 9,
    type: 'track',
    uri: 'spotify:track:1dUHF4RyMmMTveJ0Rby6Xm'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/17lzZA2AlOHwCwFALHttmp'
          },
          href: 'https://api.spotify.com/v1/artists/17lzZA2AlOHwCwFALHttmp',
          id: '17lzZA2AlOHwCwFALHttmp',
          name: '2 Chainz',
          type: 'artist',
          uri: 'spotify:artist:17lzZA2AlOHwCwFALHttmp'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/3Lh72gPELN4MIUJd3dYN6I'
      },
      href: 'https://api.spotify.com/v1/albums/3Lh72gPELN4MIUJd3dYN6I',
      id: '3Lh72gPELN4MIUJd3dYN6I',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/3ae355a2475776af30d0fff18acf339ef7d6e3f6',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/97e49b33d5a41f29c45505d6ea086e48c2521fac',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/f444dd9a81a0b52c1c09b29b2cdea86e91a5252b',
          width: 64
        }
      ],
      name: 'Bigger Than You feat. Drake & Quavo',
      type: 'album',
      uri: 'spotify:album:3Lh72gPELN4MIUJd3dYN6I'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/17lzZA2AlOHwCwFALHttmp'
        },
        href: 'https://api.spotify.com/v1/artists/17lzZA2AlOHwCwFALHttmp',
        id: '17lzZA2AlOHwCwFALHttmp',
        name: '2 Chainz',
        type: 'artist',
        uri: 'spotify:artist:17lzZA2AlOHwCwFALHttmp'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/3TVXtAsR1Inumwj472S9r4'
        },
        href: 'https://api.spotify.com/v1/artists/3TVXtAsR1Inumwj472S9r4',
        id: '3TVXtAsR1Inumwj472S9r4',
        name: 'Drake',
        type: 'artist',
        uri: 'spotify:artist:3TVXtAsR1Inumwj472S9r4'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/0VRj0yCOv2FXJNP47XQnx5'
        },
        href: 'https://api.spotify.com/v1/artists/0VRj0yCOv2FXJNP47XQnx5',
        id: '0VRj0yCOv2FXJNP47XQnx5',
        name: 'Quavo',
        type: 'artist',
        uri: 'spotify:artist:0VRj0yCOv2FXJNP47XQnx5'
      }
    ],
    disc_number: 1,
    duration_ms: 225893,
    explicit: true,
    external_ids: {
      isrc: 'USUG11801242'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/5S1IUPueD0xE0vj4zU3nSf'
    },
    href: 'https://api.spotify.com/v1/tracks/5S1IUPueD0xE0vj4zU3nSf',
    id: '5S1IUPueD0xE0vj4zU3nSf',
    is_playable: true,
    name: 'Bigger Than You (feat. Drake & Quavo)',
    popularity: 81,
    preview_url: null,
    track_number: 1,
    type: 'track',
    uri: 'spotify:track:5S1IUPueD0xE0vj4zU3nSf'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/4O15NlyKLIASxsJ0PrXPfz'
          },
          href: 'https://api.spotify.com/v1/artists/4O15NlyKLIASxsJ0PrXPfz',
          id: '4O15NlyKLIASxsJ0PrXPfz',
          name: 'Lil Uzi Vert',
          type: 'artist',
          uri: 'spotify:artist:4O15NlyKLIASxsJ0PrXPfz'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/6LX75kNicFqjjiAOeZgN67'
      },
      href: 'https://api.spotify.com/v1/albums/6LX75kNicFqjjiAOeZgN67',
      id: '6LX75kNicFqjjiAOeZgN67',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/36487b43071aa21fc75e7868852da7f059e9a1e7',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/75d389cc6c34d4fdbfc2eb7d15bc885a228d239a',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/0d966b566f58e088be775f83ce20a53f6fab6af9',
          width: 64
        }
      ],
      name: 'The Perfect LUV Tape',
      type: 'album',
      uri: 'spotify:album:6LX75kNicFqjjiAOeZgN67'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/4O15NlyKLIASxsJ0PrXPfz'
        },
        href: 'https://api.spotify.com/v1/artists/4O15NlyKLIASxsJ0PrXPfz',
        id: '4O15NlyKLIASxsJ0PrXPfz',
        name: 'Lil Uzi Vert',
        type: 'artist',
        uri: 'spotify:artist:4O15NlyKLIASxsJ0PrXPfz'
      }
    ],
    disc_number: 1,
    duration_ms: 199993,
    explicit: true,
    external_ids: {
      isrc: 'USAT21602379'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/4uhvMW7ly7tJil31YYscAN'
    },
    href: 'https://api.spotify.com/v1/tracks/4uhvMW7ly7tJil31YYscAN',
    id: '4uhvMW7ly7tJil31YYscAN',
    is_playable: true,
    name: 'Erase Your Social',
    popularity: 73,
    preview_url:
      'https://p.scdn.co/mp3-preview/e03ee047e0c8df9c576a5f543781d864eb9b83c2?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 8,
    type: 'track',
    uri: 'spotify:track:4uhvMW7ly7tJil31YYscAN'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/1pPmIToKXyGdsCF6LmqLmI'
          },
          href: 'https://api.spotify.com/v1/artists/1pPmIToKXyGdsCF6LmqLmI',
          id: '1pPmIToKXyGdsCF6LmqLmI',
          name: 'Rich The Kid',
          type: 'artist',
          uri: 'spotify:artist:1pPmIToKXyGdsCF6LmqLmI'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/1Hno6CtKbaFNAEPjRHDrc6'
      },
      href: 'https://api.spotify.com/v1/albums/1Hno6CtKbaFNAEPjRHDrc6',
      id: '1Hno6CtKbaFNAEPjRHDrc6',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/4a05d4f5bec8e872222f9a0e2adb1b1cbc91ea36',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/8324b00e7cee6262b607afad986bbac7cf310013',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/11ec672847a0c3bc71b1f662d5fd40ae9b977721',
          width: 64
        }
      ],
      name: 'The World Is Yours',
      type: 'album',
      uri: 'spotify:album:1Hno6CtKbaFNAEPjRHDrc6'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/1pPmIToKXyGdsCF6LmqLmI'
        },
        href: 'https://api.spotify.com/v1/artists/1pPmIToKXyGdsCF6LmqLmI',
        id: '1pPmIToKXyGdsCF6LmqLmI',
        name: 'Rich The Kid',
        type: 'artist',
        uri: 'spotify:artist:1pPmIToKXyGdsCF6LmqLmI'
      }
    ],
    disc_number: 1,
    duration_ms: 175229,
    explicit: true,
    external_ids: {
      isrc: 'USUM71800892'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/1ZAyjvIk9YiD76yYy0TEG6'
    },
    href: 'https://api.spotify.com/v1/tracks/1ZAyjvIk9YiD76yYy0TEG6',
    id: '1ZAyjvIk9YiD76yYy0TEG6',
    is_playable: true,
    name: 'Plug Walk',
    popularity: 83,
    preview_url: null,
    track_number: 5,
    type: 'track',
    uri: 'spotify:track:1ZAyjvIk9YiD76yYy0TEG6'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/0Y5tJX1MQlPlqiwlOH1tJY'
          },
          href: 'https://api.spotify.com/v1/artists/0Y5tJX1MQlPlqiwlOH1tJY',
          id: '0Y5tJX1MQlPlqiwlOH1tJY',
          name: 'Travis Scott',
          type: 'artist',
          uri: 'spotify:artist:0Y5tJX1MQlPlqiwlOH1tJY'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/41GuZcammIkupMPKH2OJ6I'
      },
      href: 'https://api.spotify.com/v1/albums/41GuZcammIkupMPKH2OJ6I',
      id: '41GuZcammIkupMPKH2OJ6I',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/cdca7dc20c778ada42fb18506ea1f26857f01d17',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/1ab97df000596d224199bbf7492e2bb5d09ea297',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/092f661e5290a05410f1696e608cb140461b7ebf',
          width: 64
        }
      ],
      name: 'ASTROWORLD',
      type: 'album',
      uri: 'spotify:album:41GuZcammIkupMPKH2OJ6I'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/0Y5tJX1MQlPlqiwlOH1tJY'
        },
        href: 'https://api.spotify.com/v1/artists/0Y5tJX1MQlPlqiwlOH1tJY',
        id: '0Y5tJX1MQlPlqiwlOH1tJY',
        name: 'Travis Scott',
        type: 'artist',
        uri: 'spotify:artist:0Y5tJX1MQlPlqiwlOH1tJY'
      }
    ],
    disc_number: 1,
    duration_ms: 312820,
    explicit: true,
    external_ids: {
      isrc: 'USSM11806660'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/2xLMifQCjDGFmkHkpNLD9h'
    },
    href: 'https://api.spotify.com/v1/tracks/2xLMifQCjDGFmkHkpNLD9h',
    id: '2xLMifQCjDGFmkHkpNLD9h',
    is_playable: true,
    name: 'SICKO MODE',
    popularity: 95,
    preview_url:
      'https://p.scdn.co/mp3-preview/1c3c01c64477b356e28a652b6447f4ef96689a71?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 3,
    type: 'track',
    uri: 'spotify:track:2xLMifQCjDGFmkHkpNLD9h'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/3TVXtAsR1Inumwj472S9r4'
          },
          href: 'https://api.spotify.com/v1/artists/3TVXtAsR1Inumwj472S9r4',
          id: '3TVXtAsR1Inumwj472S9r4',
          name: 'Drake',
          type: 'artist',
          uri: 'spotify:artist:3TVXtAsR1Inumwj472S9r4'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/1ATL5GLyefJaxhQzSPVrLX'
      },
      href: 'https://api.spotify.com/v1/albums/1ATL5GLyefJaxhQzSPVrLX',
      id: '1ATL5GLyefJaxhQzSPVrLX',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/542d705154be4049fc927050d006987e63739bbd',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/239ec906572231368d8ebd72614094bd3bd10b33',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/f12257240bbec6ddfa780253ac939e646eba2a36',
          width: 64
        }
      ],
      name: 'Scorpion',
      type: 'album',
      uri: 'spotify:album:1ATL5GLyefJaxhQzSPVrLX'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/3TVXtAsR1Inumwj472S9r4'
        },
        href: 'https://api.spotify.com/v1/artists/3TVXtAsR1Inumwj472S9r4',
        id: '3TVXtAsR1Inumwj472S9r4',
        name: 'Drake',
        type: 'artist',
        uri: 'spotify:artist:3TVXtAsR1Inumwj472S9r4'
      }
    ],
    disc_number: 2,
    duration_ms: 207306,
    explicit: true,
    external_ids: {
      isrc: 'USCM51800188'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/4SUwJA3eUVNHExxMPEUhQe'
    },
    href: 'https://api.spotify.com/v1/tracks/4SUwJA3eUVNHExxMPEUhQe',
    id: '4SUwJA3eUVNHExxMPEUhQe',
    is_playable: true,
    name: 'Ratchet Happy Birthday',
    popularity: 73,
    preview_url: null,
    track_number: 6,
    type: 'track',
    uri: 'spotify:track:4SUwJA3eUVNHExxMPEUhQe'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/6l3HvQ5sa6mXTsMTB19rO5'
          },
          href: 'https://api.spotify.com/v1/artists/6l3HvQ5sa6mXTsMTB19rO5',
          id: '6l3HvQ5sa6mXTsMTB19rO5',
          name: 'J. Cole',
          type: 'artist',
          uri: 'spotify:artist:6l3HvQ5sa6mXTsMTB19rO5'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/7viNUmZZ8ztn2UB4XB3jIL'
      },
      href: 'https://api.spotify.com/v1/albums/7viNUmZZ8ztn2UB4XB3jIL',
      id: '7viNUmZZ8ztn2UB4XB3jIL',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/9c5d0ed04c5d5ca1fb3027cdc860698c89da4942',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/176606ea8b00ee668e47de155c95a6fc1418bad6',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/cdae307053d659a38434177323ea03902ac8b0dc',
          width: 64
        }
      ],
      name: '2014 Forest Hills Drive',
      type: 'album',
      uri: 'spotify:album:7viNUmZZ8ztn2UB4XB3jIL'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/6l3HvQ5sa6mXTsMTB19rO5'
        },
        href: 'https://api.spotify.com/v1/artists/6l3HvQ5sa6mXTsMTB19rO5',
        id: '6l3HvQ5sa6mXTsMTB19rO5',
        name: 'J. Cole',
        type: 'artist',
        uri: 'spotify:artist:6l3HvQ5sa6mXTsMTB19rO5'
      }
    ],
    disc_number: 1,
    duration_ms: 292986,
    explicit: true,
    external_ids: {
      isrc: 'USQX91402598'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/62vpWI1CHwFy7tMIcSStl8'
    },
    href: 'https://api.spotify.com/v1/tracks/62vpWI1CHwFy7tMIcSStl8',
    id: '62vpWI1CHwFy7tMIcSStl8',
    is_playable: true,
    name: 'No Role Modelz',
    popularity: 80,
    preview_url:
      'https://p.scdn.co/mp3-preview/ef67372f58306c52484caadd120b0455e3fe2e6d?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 9,
    type: 'track',
    uri: 'spotify:track:62vpWI1CHwFy7tMIcSStl8'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/7c0XG5cIJTrrAgEC3ULPiq'
          },
          href: 'https://api.spotify.com/v1/artists/7c0XG5cIJTrrAgEC3ULPiq',
          id: '7c0XG5cIJTrrAgEC3ULPiq',
          name: 'Ty Dolla $ign',
          type: 'artist',
          uri: 'spotify:artist:7c0XG5cIJTrrAgEC3ULPiq'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/7Dj0aaKI4RpehMPqOu56mW'
      },
      href: 'https://api.spotify.com/v1/albums/7Dj0aaKI4RpehMPqOu56mW',
      id: '7Dj0aaKI4RpehMPqOu56mW',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/f71baf14611a39b3cbd652c028b4aa4210016071',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/efb471e84650dd43adbb51fad9108406bb6db02b',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/87fe85296eda0abd4909d8a16c8b6aec67da151a',
          width: 64
        }
      ],
      name: 'Beach House 3',
      type: 'album',
      uri: 'spotify:album:7Dj0aaKI4RpehMPqOu56mW'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/7c0XG5cIJTrrAgEC3ULPiq'
        },
        href: 'https://api.spotify.com/v1/artists/7c0XG5cIJTrrAgEC3ULPiq',
        id: '7c0XG5cIJTrrAgEC3ULPiq',
        name: 'Ty Dolla $ign',
        type: 'artist',
        uri: 'spotify:artist:7c0XG5cIJTrrAgEC3ULPiq'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/55Aa2cqylxrFIXC767Z865'
        },
        href: 'https://api.spotify.com/v1/artists/55Aa2cqylxrFIXC767Z865',
        id: '55Aa2cqylxrFIXC767Z865',
        name: 'Lil Wayne',
        type: 'artist',
        uri: 'spotify:artist:55Aa2cqylxrFIXC767Z865'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/1W3FSF1BLpY3hlVIgvenLz'
        },
        href: 'https://api.spotify.com/v1/artists/1W3FSF1BLpY3hlVIgvenLz',
        id: '1W3FSF1BLpY3hlVIgvenLz',
        name: 'The-Dream',
        type: 'artist',
        uri: 'spotify:artist:1W3FSF1BLpY3hlVIgvenLz'
      }
    ],
    disc_number: 1,
    duration_ms: 181880,
    explicit: true,
    external_ids: {
      isrc: 'USAT21702235'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/270aLuFCbX32hhBr8MQyPM'
    },
    href: 'https://api.spotify.com/v1/tracks/270aLuFCbX32hhBr8MQyPM',
    id: '270aLuFCbX32hhBr8MQyPM',
    is_playable: true,
    name: 'Love U Better (feat. Lil Wayne & The-Dream)',
    popularity: 73,
    preview_url:
      'https://p.scdn.co/mp3-preview/8917010fb6f1883ff95e85abf35428d98904f29b?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 3,
    type: 'track',
    uri: 'spotify:track:270aLuFCbX32hhBr8MQyPM'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/4qBgvVog0wzW75IQ48mU7v'
          },
          href: 'https://api.spotify.com/v1/artists/4qBgvVog0wzW75IQ48mU7v',
          id: '4qBgvVog0wzW75IQ48mU7v',
          name: 'KYLE',
          type: 'artist',
          uri: 'spotify:artist:4qBgvVog0wzW75IQ48mU7v'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/2c1ipXPsfn6ylm6PrQNuDU'
      },
      href: 'https://api.spotify.com/v1/albums/2c1ipXPsfn6ylm6PrQNuDU',
      id: '2c1ipXPsfn6ylm6PrQNuDU',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/9c26617a0f2f2336ad752095d0cca885196283ae',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/74e4e22ce067ae84c233d7e957e6a8e02497623a',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/e97a8ff3fc7b73e0cee5500ea86071cf62e774a5',
          width: 64
        }
      ],
      name: 'Light of Mine',
      type: 'album',
      uri: 'spotify:album:2c1ipXPsfn6ylm6PrQNuDU'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/4qBgvVog0wzW75IQ48mU7v'
        },
        href: 'https://api.spotify.com/v1/artists/4qBgvVog0wzW75IQ48mU7v',
        id: '4qBgvVog0wzW75IQ48mU7v',
        name: 'KYLE',
        type: 'artist',
        uri: 'spotify:artist:4qBgvVog0wzW75IQ48mU7v'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/0cGUm45nv7Z6M6qdXYQGTX'
        },
        href: 'https://api.spotify.com/v1/artists/0cGUm45nv7Z6M6qdXYQGTX',
        id: '0cGUm45nv7Z6M6qdXYQGTX',
        name: 'Kehlani',
        type: 'artist',
        uri: 'spotify:artist:0cGUm45nv7Z6M6qdXYQGTX'
      }
    ],
    disc_number: 1,
    duration_ms: 191680,
    explicit: false,
    external_ids: {
      isrc: 'USAT21801141'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/4F1yvJfQ7gJkrcgFJQDjOr'
    },
    href: 'https://api.spotify.com/v1/tracks/4F1yvJfQ7gJkrcgFJQDjOr',
    id: '4F1yvJfQ7gJkrcgFJQDjOr',
    is_playable: true,
    name: 'Playinwitme (feat. Kehlani)',
    popularity: 85,
    preview_url:
      'https://p.scdn.co/mp3-preview/05e8881d5c896a8d147d2e79150fb5480a4fb186?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 9,
    type: 'track',
    uri: 'spotify:track:4F1yvJfQ7gJkrcgFJQDjOr'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/5K4W6rqBFWDnAN6FQUkS6x'
          },
          href: 'https://api.spotify.com/v1/artists/5K4W6rqBFWDnAN6FQUkS6x',
          id: '5K4W6rqBFWDnAN6FQUkS6x',
          name: 'Kanye West',
          type: 'artist',
          uri: 'spotify:artist:5K4W6rqBFWDnAN6FQUkS6x'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/20r762YmB5HeofjMCiPMLv'
      },
      href: 'https://api.spotify.com/v1/albums/20r762YmB5HeofjMCiPMLv',
      id: '20r762YmB5HeofjMCiPMLv',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/cafd8763a050dabc4f6157172bb09a23d09abde3',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/9e27d58cc64c1c4fc97034ba83c6b938d24582f6',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/6cf0001035578534d00d37b0371108f24fbf63c9',
          width: 64
        }
      ],
      name: 'My Beautiful Dark Twisted Fantasy',
      type: 'album',
      uri: 'spotify:album:20r762YmB5HeofjMCiPMLv'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/5K4W6rqBFWDnAN6FQUkS6x'
        },
        href: 'https://api.spotify.com/v1/artists/5K4W6rqBFWDnAN6FQUkS6x',
        id: '5K4W6rqBFWDnAN6FQUkS6x',
        name: 'Kanye West',
        type: 'artist',
        uri: 'spotify:artist:5K4W6rqBFWDnAN6FQUkS6x'
      }
    ],
    disc_number: 1,
    duration_ms: 292093,
    explicit: true,
    external_ids: {
      isrc: 'USUM71018220'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/2gZUPNdnz5Y45eiGxpHGSc'
    },
    href: 'https://api.spotify.com/v1/tracks/2gZUPNdnz5Y45eiGxpHGSc',
    id: '2gZUPNdnz5Y45eiGxpHGSc',
    is_playable: true,
    name: 'POWER',
    popularity: 76,
    preview_url: null,
    track_number: 3,
    type: 'track',
    uri: 'spotify:track:2gZUPNdnz5Y45eiGxpHGSc'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/50co4Is1HCEo8bhOyUWKpn'
          },
          href: 'https://api.spotify.com/v1/artists/50co4Is1HCEo8bhOyUWKpn',
          id: '50co4Is1HCEo8bhOyUWKpn',
          name: 'Young Thug',
          type: 'artist',
          uri: 'spotify:artist:50co4Is1HCEo8bhOyUWKpn'
        },
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/1xr2G8Hlx4QWmT9HaUbmoO'
          },
          href: 'https://api.spotify.com/v1/artists/1xr2G8Hlx4QWmT9HaUbmoO',
          id: '1xr2G8Hlx4QWmT9HaUbmoO',
          name: 'Young Stoner Life Records',
          type: 'artist',
          uri: 'spotify:artist:1xr2G8Hlx4QWmT9HaUbmoO'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/4OHfmMUq6xwCo8zfQuc9Rf'
      },
      href: 'https://api.spotify.com/v1/albums/4OHfmMUq6xwCo8zfQuc9Rf',
      id: '4OHfmMUq6xwCo8zfQuc9Rf',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/99404833351cba4c0e0b2b9add62193ccfd89bb7',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/7968429777550657adadc1a2a95c18d7bb92fcfa',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/aea65584802a42e6d70b7f5c9ca64498c8fe3ebf',
          width: 64
        }
      ],
      name: 'Slime Language',
      type: 'album',
      uri: 'spotify:album:4OHfmMUq6xwCo8zfQuc9Rf'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/50co4Is1HCEo8bhOyUWKpn'
        },
        href: 'https://api.spotify.com/v1/artists/50co4Is1HCEo8bhOyUWKpn',
        id: '50co4Is1HCEo8bhOyUWKpn',
        name: 'Young Thug',
        type: 'artist',
        uri: 'spotify:artist:50co4Is1HCEo8bhOyUWKpn'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/1xr2G8Hlx4QWmT9HaUbmoO'
        },
        href: 'https://api.spotify.com/v1/artists/1xr2G8Hlx4QWmT9HaUbmoO',
        id: '1xr2G8Hlx4QWmT9HaUbmoO',
        name: 'Young Stoner Life Records',
        type: 'artist',
        uri: 'spotify:artist:1xr2G8Hlx4QWmT9HaUbmoO'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/4O15NlyKLIASxsJ0PrXPfz'
        },
        href: 'https://api.spotify.com/v1/artists/4O15NlyKLIASxsJ0PrXPfz',
        id: '4O15NlyKLIASxsJ0PrXPfz',
        name: 'Lil Uzi Vert',
        type: 'artist',
        uri: 'spotify:artist:4O15NlyKLIASxsJ0PrXPfz'
      }
    ],
    disc_number: 1,
    duration_ms: 142840,
    explicit: true,
    external_ids: {
      isrc: 'USAT21810483'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/3HxYOwZZHZn5mC1drqPQqR'
    },
    href: 'https://api.spotify.com/v1/tracks/3HxYOwZZHZn5mC1drqPQqR',
    id: '3HxYOwZZHZn5mC1drqPQqR',
    is_playable: true,
    name: "It's A Slime (feat. Lil Uzi Vert)",
    popularity: 73,
    preview_url:
      'https://p.scdn.co/mp3-preview/2d4b682ab2793e7b8d741b4475c6724d84408e9d?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 8,
    type: 'track',
    uri: 'spotify:track:3HxYOwZZHZn5mC1drqPQqR'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/3TVXtAsR1Inumwj472S9r4'
          },
          href: 'https://api.spotify.com/v1/artists/3TVXtAsR1Inumwj472S9r4',
          id: '3TVXtAsR1Inumwj472S9r4',
          name: 'Drake',
          type: 'artist',
          uri: 'spotify:artist:3TVXtAsR1Inumwj472S9r4'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/1ATL5GLyefJaxhQzSPVrLX'
      },
      href: 'https://api.spotify.com/v1/albums/1ATL5GLyefJaxhQzSPVrLX',
      id: '1ATL5GLyefJaxhQzSPVrLX',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/542d705154be4049fc927050d006987e63739bbd',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/239ec906572231368d8ebd72614094bd3bd10b33',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/f12257240bbec6ddfa780253ac939e646eba2a36',
          width: 64
        }
      ],
      name: 'Scorpion',
      type: 'album',
      uri: 'spotify:album:1ATL5GLyefJaxhQzSPVrLX'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/3TVXtAsR1Inumwj472S9r4'
        },
        href: 'https://api.spotify.com/v1/artists/3TVXtAsR1Inumwj472S9r4',
        id: '3TVXtAsR1Inumwj472S9r4',
        name: 'Drake',
        type: 'artist',
        uri: 'spotify:artist:3TVXtAsR1Inumwj472S9r4'
      }
    ],
    disc_number: 1,
    duration_ms: 238614,
    explicit: true,
    external_ids: {
      isrc: 'USCM51800191'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/0TlLq3lA83rQOYtrqBqSct'
    },
    href: 'https://api.spotify.com/v1/tracks/0TlLq3lA83rQOYtrqBqSct',
    id: '0TlLq3lA83rQOYtrqBqSct',
    is_playable: true,
    name: 'Nonstop',
    popularity: 92,
    preview_url: null,
    track_number: 2,
    type: 'track',
    uri: 'spotify:track:0TlLq3lA83rQOYtrqBqSct'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/0Y5tJX1MQlPlqiwlOH1tJY'
          },
          href: 'https://api.spotify.com/v1/artists/0Y5tJX1MQlPlqiwlOH1tJY',
          id: '0Y5tJX1MQlPlqiwlOH1tJY',
          name: 'Travis Scott',
          type: 'artist',
          uri: 'spotify:artist:0Y5tJX1MQlPlqiwlOH1tJY'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/42WVQWuf1teDysXiOupIZt'
      },
      href: 'https://api.spotify.com/v1/albums/42WVQWuf1teDysXiOupIZt',
      id: '42WVQWuf1teDysXiOupIZt',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/6c41981dc659cc8a19a0371f42951d8dec48db7c',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/ea447323073c2208e8cf64b0fc3250cc37c71c6c',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/0273528fb5036f6573d4765f74f08e5c5ac1fe92',
          width: 64
        }
      ],
      name: 'Birds In The Trap Sing McKnight',
      type: 'album',
      uri: 'spotify:album:42WVQWuf1teDysXiOupIZt'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/0Y5tJX1MQlPlqiwlOH1tJY'
        },
        href: 'https://api.spotify.com/v1/artists/0Y5tJX1MQlPlqiwlOH1tJY',
        id: '0Y5tJX1MQlPlqiwlOH1tJY',
        name: 'Travis Scott',
        type: 'artist',
        uri: 'spotify:artist:0Y5tJX1MQlPlqiwlOH1tJY'
      }
    ],
    disc_number: 1,
    duration_ms: 213863,
    explicit: true,
    external_ids: {
      isrc: 'USSM11607551'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/0ESJlaM8CE1jRWaNtwSNj8'
    },
    href: 'https://api.spotify.com/v1/tracks/0ESJlaM8CE1jRWaNtwSNj8',
    id: '0ESJlaM8CE1jRWaNtwSNj8',
    is_playable: true,
    name: 'beibs in the trap',
    popularity: 75,
    preview_url:
      'https://p.scdn.co/mp3-preview/c5e2f314d4897ef42756cbbd8343033d80aca9fb?cid=774b29d4f13844c495f206cafdad9c86',
    track_number: 5,
    type: 'track',
    uri: 'spotify:track:0ESJlaM8CE1jRWaNtwSNj8'
  },
  {
    album: {
      album_type: 'ALBUM',
      artists: [
        {
          external_urls: {
            spotify: 'https://open.spotify.com/artist/2jku7tDXc6XoB6MO2hFuqg'
          },
          href: 'https://api.spotify.com/v1/artists/2jku7tDXc6XoB6MO2hFuqg',
          id: '2jku7tDXc6XoB6MO2hFuqg',
          name: 'Tory Lanez',
          type: 'artist',
          uri: 'spotify:artist:2jku7tDXc6XoB6MO2hFuqg'
        }
      ],
      external_urls: {
        spotify: 'https://open.spotify.com/album/5Ezs1ZUquwvBK0vCRt7eVx'
      },
      href: 'https://api.spotify.com/v1/albums/5Ezs1ZUquwvBK0vCRt7eVx',
      id: '5Ezs1ZUquwvBK0vCRt7eVx',
      images: [
        {
          height: 640,
          url: 'https://i.scdn.co/image/eb24864602f826f7774ffaafb35292093927dcf9',
          width: 640
        },
        {
          height: 300,
          url: 'https://i.scdn.co/image/5f09f162b4066cd029b96d72fd6b9dc82a333447',
          width: 300
        },
        {
          height: 64,
          url: 'https://i.scdn.co/image/16968ffab8235a28a65e674da4ae16a2e9944962',
          width: 64
        }
      ],
      name: 'KeeP IN tOUcH (feat. Bryson Tiller)',
      type: 'album',
      uri: 'spotify:album:5Ezs1ZUquwvBK0vCRt7eVx'
    },
    artists: [
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/2jku7tDXc6XoB6MO2hFuqg'
        },
        href: 'https://api.spotify.com/v1/artists/2jku7tDXc6XoB6MO2hFuqg',
        id: '2jku7tDXc6XoB6MO2hFuqg',
        name: 'Tory Lanez',
        type: 'artist',
        uri: 'spotify:artist:2jku7tDXc6XoB6MO2hFuqg'
      },
      {
        external_urls: {
          spotify: 'https://open.spotify.com/artist/2EMAnMvWE2eb56ToJVfCWs'
        },
        href: 'https://api.spotify.com/v1/artists/2EMAnMvWE2eb56ToJVfCWs',
        id: '2EMAnMvWE2eb56ToJVfCWs',
        name: 'Bryson Tiller',
        type: 'artist',
        uri: 'spotify:artist:2EMAnMvWE2eb56ToJVfCWs'
      }
    ],
    disc_number: 1,
    duration_ms: 199462,
    explicit: true,
    external_ids: {
      isrc: 'USUM71811232'
    },
    external_urls: {
      spotify: 'https://open.spotify.com/track/7hxREMLAebTcuadofbuyJj'
    },
    href: 'https://api.spotify.com/v1/tracks/7hxREMLAebTcuadofbuyJj',
    id: '7hxREMLAebTcuadofbuyJj',
    is_playable: true,
    name: 'KeeP IN tOUcH (feat. Bryson Tiller)',
    popularity: 73,
    preview_url: null,
    track_number: 1,
    type: 'track',
    uri: 'spotify:track:7hxREMLAebTcuadofbuyJj'
  }
];



// WEBPACK FOOTER //
// ./src/utils/data/drake.js